import { AccordionStep } from '@hb/domain';
import { AnalyticType, ButtonKey, Keys, question, QuestionKey } from '@hb/modules/global/global.constants';
import { formName, type } from '@hb/services/analytics/analytics.constants';

import { Injectable } from '@angular/core';

import { ApAnalyticsService, ErrorAnalyticsData, FormFieldValue, FormStepAnalyticsData } from '@ap/analytics';
import { MortgageCalculation, MortgageCalculationResponse } from '@ap/ap-interface-apix-hypotheken-berekening';

@Injectable({
    providedIn: 'root'
})
export class AnalyticsService extends ApAnalyticsService {
    mortgage: MortgageCalculation;

    sendResult(step: AccordionStep, result: MortgageCalculationResponse): void {
        const resultDetail = result.mortgage?.expected_mortgage
            ? result.mortgage.expected_mortgage
            : result.mortgage.max_mortgage_by_income;
        const resultLabel = result.mortgage?.expected_mortgage ? 'expected_mortgage' : 'max_mortgage_by_income';
        const key = result.mortgage?.expected_mortgage ? ButtonKey.EXPECTED_MORTGAGE : ButtonKey.MORTGAGE_INCOME;

        const data = new FormStepAnalyticsData(formName, type, Keys.getStepAsString(step).toLowerCase(), step, 'success', [
            new FormFieldValue(resultLabel, this.getAnonymizedValue(resultDetail.amount.amount, key))
        ]);
        this.push(data);
    }

    sendValueUpdate(key: QuestionKey, value: any): void {
        const data = new FormStepAnalyticsData(formName, type, Keys.getStepAsStringByKey(key).toLowerCase(), Keys.getStep(key), 'success', [
            new FormFieldValue(key.toLowerCase(), this.getAnonymizedValue(value, key))
        ]);
        this.push(data);
    }

    sendErrorState(step: string, value: string): void {
        this.push(new ErrorAnalyticsData(formName, 'validation_error', step.toLowerCase(), value.toLowerCase()));
    }

    sendClickUpdate(elementType: string, key: QuestionKey | ButtonKey) {
        const data = new FormStepAnalyticsData(formName, type, Keys.getStepAsStringByKey(key).toLowerCase(), Keys.getStep(key), 'success', [
            new FormFieldValue(key.toLowerCase(), elementType?.toString().toLowerCase())
        ]);
        this.push(data);
    }

    getAnonymizedValue(value: any, key: QuestionKey | ButtonKey): string {
        const questionValue = question.find((validator) => validator.key === key);
        if (questionValue.analytics?.type === AnalyticType.AMOUNT) {
            return AnalyticsService.anonymizers.amount(value.toString(), questionValue.analytics?.range);
        }
        if (questionValue.analytics?.type === AnalyticType.DATE) {
            return AnalyticsService.anonymizers.date(value);
        }
        if (questionValue.analytics?.type === AnalyticType.AGE) {
            return AnalyticsService.anonymizers.amount(AnalyticsService.anonymizers.birthDate(value), questionValue.analytics.range);
        }
        return value.toString();
    }
}
